var _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 162,
    viewBox: "0 0 178 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 87,
    cy: 85,
    r: 64,
    fill: "#FF8F34"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.34693,
    y1: 38.569,
    x2: 37.569,
    y2: 54.6531,
    stroke: "url(#paint0_linear)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15.912,
    y1: 91.0532,
    x2: 50.908,
    y2: 88.088,
    stroke: "url(#paint1_linear)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5713,
    y1: 127.84,
    x2: 20.7063,
    y2: 120.429,
    stroke: "url(#paint2_linear)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 48.1353,
    y1: 153.431,
    x2: 61.1944,
    y2: 133.603,
    stroke: "url(#paint3_linear)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 121.906,
    y1: 135.773,
    x2: 106.86,
    y2: 117.407,
    stroke: "url(#paint4_linear)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 158.521,
    y1: 116.294,
    x2: 136.547,
    y2: 107.304,
    stroke: "url(#paint5_linear)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 142.301,
    y1: 67.2043,
    x2: 119.204,
    y2: 72.7009,
    stroke: "url(#paint6_linear)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 92.4741,
    y1: 155.816,
    x2: 91.1321,
    y2: 145.117,
    stroke: "url(#paint7_linear)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 126.991,
    y1: 31.4142,
    x2: 119.414,
    y2: 38.8903,
    stroke: "url(#paint8_linear)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 162.559,
    y1: 32.509,
    x2: 153.487,
    y2: 38.0766,
    stroke: "url(#paint9_linear)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 78.1094,
    y1: 1.87709,
    x2: 81.298,
    y2: 29.146,
    stroke: "url(#paint10_linear)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 176.443,
    y1: 81.6579,
    x2: 148.992,
    y2: 82.0853,
    stroke: "url(#paint11_linear)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 56.3944,
    y1: 39.2358,
    x2: 64.6567,
    y2: 50.8609,
    stroke: "url(#paint12_linear)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 85,
    r: 41,
    fill: "url(#paint13_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.8 82.0533C95.8933 77.4533 91.8533 74 87 74C83.1467 74 79.8 76.1867 78.1333 79.3867C74.12 79.8133 71 83.2133 71 87.3333C71 91.7467 74.5867 95.3333 79 95.3333H96.3333C100.013 95.3333 103 92.3467 103 88.6667C103 85.1467 100.267 82.2933 96.8 82.0533ZM89.6667 86V91.3333H84.3333V86H80.3333L87 79.3333L93.6667 86H89.6667Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 22,
    y: 32,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.560583 0 0 0 0 0.204167 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.45797,
    y1: 38.111,
    x2: 38.458,
    y2: 55.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.9156,
    y1: 91.1376,
    x2: 51.9045,
    y2: 88.0035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 0.638803,
    y1: 128.202,
    x2: 21.6388,
    y2: 120.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 47.5853,
    y1: 154.266,
    x2: 61.7444,
    y2: 132.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 122.54,
    y1: 136.546,
    x2: 106.227,
    y2: 116.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 159.446,
    y1: 116.673,
    x2: 135.621,
    y2: 106.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 143.274,
    y1: 66.9729,
    x2: 118.231,
    y2: 72.9325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 92.5986,
    y1: 156.808,
    x2: 91.0077,
    y2: 144.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 127.702,
    y1: 30.7118,
    x2: 118.702,
    y2: 39.5927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 163.411,
    y1: 31.9859,
    x2: 152.635,
    y2: 38.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 77.9933,
    y1: 0.883858,
    x2: 81.4141,
    y2: 30.1392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 177.443,
    y1: 81.6424,
    x2: 147.992,
    y2: 82.1009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 55.8151,
    y1: 38.4207,
    x2: 65.236,
    y2: 51.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 87,
    y1: 44,
    x2: 87,
    y2: 126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38124"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploading);
export default __webpack_public_path__ + "static/media/icon-uploading.2a586e33e002cfe7ac34c030b1a33a66.svg";
export { ForwardRef as ReactComponent };